/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BillingContact } from './';
import {
    BillingContactFromJSON,
    BillingContactFromJSONTyped,
    BillingContactToJSON,
} from './';
import type { InvoicingSettings } from './';
import {
    InvoicingSettingsFromJSON,
    InvoicingSettingsFromJSONTyped,
    InvoicingSettingsToJSON,
} from './';
import type { LegalInformation } from './';
import {
    LegalInformationFromJSON,
    LegalInformationFromJSONTyped,
    LegalInformationToJSON,
} from './';
import type { PaymentSettings } from './';
import {
    PaymentSettingsFromJSON,
    PaymentSettingsFromJSONTyped,
    PaymentSettingsToJSON,
} from './';

/**
 * 
 * @export
 * @interface LegalEntityResource
 */
export interface LegalEntityResource {
    /**
     * 
     * @type {string}
     * @memberof LegalEntityResource
     */
    legalEntityId: string;
    /**
     * 
     * @type {LegalInformation}
     * @memberof LegalEntityResource
     */
    legalInformation: LegalInformation;
    /**
     * 
     * @type {BillingContact}
     * @memberof LegalEntityResource
     */
    billingContact: BillingContact;
    /**
     * 
     * @type {PaymentSettings}
     * @memberof LegalEntityResource
     */
    paymentSettings: PaymentSettings;
    /**
     * 
     * @type {InvoicingSettings}
     * @memberof LegalEntityResource
     */
    invoicingSettings: InvoicingSettings;
    /**
     * 
     * @type {Set<string>}
     * @memberof LegalEntityResource
     */
    clientTeams: Set<string>;
    /**
     * 
     * @type {boolean}
     * @memberof LegalEntityResource
     */
    isArchived?: boolean;
}

/**
 * Check if a given object implements the LegalEntityResource interface.
 */
export function instanceOfLegalEntityResource(value: object): value is LegalEntityResource {
    if (!('legalEntityId' in value) || value['legalEntityId'] === undefined) return false;
    if (!('legalInformation' in value) || value['legalInformation'] === undefined) return false;
    if (!('billingContact' in value) || value['billingContact'] === undefined) return false;
    if (!('paymentSettings' in value) || value['paymentSettings'] === undefined) return false;
    if (!('invoicingSettings' in value) || value['invoicingSettings'] === undefined) return false;
    if (!('clientTeams' in value) || value['clientTeams'] === undefined) return false;
    return true;
}

export function LegalEntityResourceFromJSON(json: any): LegalEntityResource {
    return LegalEntityResourceFromJSONTyped(json, false);
}

export function LegalEntityResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalEntityResource {
    if (json == null) {
        return json;
    }
    return {
        
        'legalEntityId': json['legalEntityId'],
        'legalInformation': LegalInformationFromJSON(json['legalInformation']),
        'billingContact': BillingContactFromJSON(json['billingContact']),
        'paymentSettings': PaymentSettingsFromJSON(json['paymentSettings']),
        'invoicingSettings': InvoicingSettingsFromJSON(json['invoicingSettings']),
        'clientTeams': json['clientTeams'],
        'isArchived': json['isArchived'] == null ? undefined : json['isArchived'],
    };
}

export function LegalEntityResourceToJSON(value?: LegalEntityResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalEntityId': value['legalEntityId'],
        'legalInformation': LegalInformationToJSON(value['legalInformation']),
        'billingContact': BillingContactToJSON(value['billingContact']),
        'paymentSettings': PaymentSettingsToJSON(value['paymentSettings']),
        'invoicingSettings': InvoicingSettingsToJSON(value['invoicingSettings']),
        'clientTeams': Array.from(value['clientTeams'] as Set<any>),
        'isArchived': value['isArchived'],
    };
}

